module.exports = __webpack_public_path__ + "static/media/grilledwatermelon.c8cbec1a.webp";